import React from "react";

const ContactUs = () => {
	return (
	<div className="lp-container contact-us-container">
      <h1>Questions?</h1>
      <h3>We're happy to help! Feel free to contact us anytime.</h3>
      <div className="flex-container">
        <div className="half">
          <div className="form-container">
            <iframe src="https://us1.list-manage.com/contact-form?u=71dcdf7c88eec7bef365fece1&form_id=18507207bedd5734f277882a57e4f7fa" width="640" height="860" />
          </div>
        </div>
      </div>
    </div>
	);
};

export default ContactUs;
